var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"modal-card-body p-0"},[_c('iframe',{attrs:{"src":_vm.info.url,"title":_vm.info.title,"height":"200","width":"100%","allow":"autoplay; fullscreen; xr-spatial-tracking"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }